import React from 'react';
import smallAreas from '../../helpers/small-areas';
import styles from './small-area.module.scss';
export default function SmallAreaList({ onClick }) {
  const baseUrl = process.env.PUBLIC_URL || '';
  return (
    <ul className={styles.smallAreaList}>
      {smallAreas.map(({ name, icon }) => {
        return (
          <li
            key={name}
            role="button"
            onClick={onClick({ id: name })}
            className={styles.smallArea}
          >
            <img src={baseUrl + icon} alt={name} />{' '}
            <span className={styles.name}>{name}</span>
          </li>
        );
      })}
    </ul>
  );
}



// WEBPACK FOOTER //
// ./src/components/small-area-list/small-area-list.js